import {AddressSearchResult, SearchAddressInterface} from '@/src/ports/services/address-search'
import {inject, injectable} from 'inversify'
import {DI} from '@/src/config/di/types'
import type {IApiClientServiceFactory} from '@/src/ports/services/api'
import {Routes} from '@/src/config/routes'

@injectable()
export class DadataSearchAddress implements SearchAddressInterface {
  @inject(DI.IApiClientServiceFactory)
  apiClientFactory!: IApiClientServiceFactory

  async search(
    city: string,
    text: string,
    city_fias_id?: string,
    settlement_fias_id?: string,
  ): Promise<AddressSearchResult[]> {
    const client = this.apiClientFactory('api')

    return await client.get(Routes.api.daDataAddress.search, {
      params: {text, city, city_fias_id, settlement_fias_id},
    })
  }
}
